import React from "react";
import {ConfirmModal, useNotifications} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {api} from "@/data/api";

export type DeleteLoyaltyRewardState = {
    showModal: boolean,
    loyaltyRewardId: number,
};

type Props = {
    show: boolean,
    setShow: (show: boolean) => void,
    loyaltyRewardId: number,
    cb: (remainingFeaturedProducts: LoyaltyRewardDetails[]) => void,
};

const DeleteLoyaltyRewardModal = ({show, setShow, loyaltyRewardId, cb}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const {dashboardLocation} = useRestaurant();
    const {mutate, isPending} = useMutation({
        mutationFn: (loyaltyRewardId: number) => api.loyaltyReward.deleteLoyaltyReward(dashboardLocation.id, loyaltyRewardId),
        onSuccess: (result) => {
            cb(result);
            setShow(false);
            notifySuccess(intl.formatMessage({id: "deleted"}), notify)
        },
        onError: () => {
            notifyDanger(intl.formatMessage({id: "systemError"}), notify);
        },
    });

    return (
        <ConfirmModal
            type={"danger"}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "deleteLoyaltyReward"})}
            dismissButton={{
                text: intl.formatMessage({id: "cancel"}),
            }}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => mutate(loyaltyRewardId),
                props: {color: "danger"},
            }}
            disabled={isPending}
            loading={isPending}
            position={"center-bottom"}
            breakpoints={{md: {position: "center"}}}
        >
            <FormattedMessage id={"confirmDeleteLoyaltyReward"}/>
        </ConfirmModal>
    );
};

export default DeleteLoyaltyRewardModal;